import { pushEvent } from '../../../client/data-layer';

export const trackContentViewed = (id: string) => {
  pushEvent('contentViewed', { id });
};
